import AuthFileUploader from "../../common/AuthFileUploader";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { notifyMsg } from "../../common/notify";
import { updateLoginPopupVisible } from "../../common/Redux/login";
import { confirm } from "devextreme/ui/dialog";
import ContractListDataGrid from "../ContractListDataGrid";
import { invalidateTaskList } from "../../WorkingTimeTable/WorkRecord/Redux/taskList";

import "./index.css";

export default function ContractRegistration() {
  // const [selectedFile, setSelectedFile] = useState(null);
  // const [upload, setUpload] = useState(false);
  const [uploadedContrNo, setUploadedContrNo] = useState(null);
  const [pendingFile, setPendingFile] = useState(null);
  // const [upload, setUpload] = useState(false);

  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Contract Registration";

    if (userInfo.employeeNo == null) {
      dispatch(updateLoginPopupVisible(true));
    }
  }, []);

  const onUploadStarted = (e) => {
    setUploadedContrNo(null);
    setPendingFile(e.file);
  };

  const performForceUpload = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const res = await fetch(`${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/`, {
      method: "POST",
      credentials: "include",
      headers: { "X-Force-Replace": "true" },
      body: formData,
    });
    if (res.ok) {
      const contrNo = await res.text();
      dispatch(invalidateTaskList());
      setUploadedContrNo(contrNo);
      notifyMsg("견적서가 업로드되었습니다.", "success");
      setPendingFile(null);
    } else {
      const err = await res.json().catch(() => ({}));
      notifyMsg(err.message || "업로드에 실패했습니다.", "error");
    }
  };

  const onUploaded = (e) => {
    const { file } = e;

    // setUploaded(true);
    dispatch(invalidateTaskList());
    setUploadedContrNo(e.request.responseText);

    // setSelectedRowKeys(Array.of(e.request.responseText));
    notifyMsg("견적서가 업로드되었습니다.", "success");
  };

  const onUploadError = async (e) => {
    if (e.request.status === 409) {
      const { quotNo, message } = JSON.parse(e.error.response);
      const confirmed = await confirm(`${message}<br/>현재 파일로 교체하시겠습니까?`, "확인");
      if (confirmed) {
        await performForceUpload(pendingFile);
      } else {
        notifyMsg(message, "error");
      }
    } else if (e.error.response) {
      notifyMsg(JSON.parse(e.error.response).message, "error");
    } else {
      notifyMsg(
        `${e.file.name} 파일이 이미 사용 중입니다. 새 이름을 선택하거나 다른 응용 프로그램에서 사용 중인 파일을 닫으십시오.`,
        "error"
      );
    }
  };

  return (
    <React.Fragment>
      {/* <form
        ref={fileUploaderRef}
        method="post"
        encType="multipart/form-data"
        target="quotationIframe"
      > */}
      {/* <Header title={"File Upload"} /> */}
      {userInfo.employeeNo && (
        <div>
          <div className="file-uploader-block">
            <AuthFileUploader
              id="contractRegistrationFileUploader"
              uploadMode="instantly"
              uploadUrl={`${process.env.REACT_APP_BECCO_API_URL}/api/contrReg/`}
              // uploadUrl={`https://betree.beccocro.com:9000/api/contrReg/`}
              accept=".xlsx"
              allowedFileExtensions={[".xlsx"]}
              showFileList={false}
              onUploadStarted={onUploadStarted}
              onUploaded={onUploaded}
              onUploadError={onUploadError}
            />
          </div>
          <ContractListDataGrid
            uploadedContrNo={uploadedContrNo}
            path="ContrReg"
            title="CONTRACT LIST"
          />
        </div>
      )}
    </React.Fragment>
  );
}
